<template>
  <div class="q-my-sm text-h6" :class="$q.dark.mode ? '' : 'text-primary'">
    <span>{{ title }}</span>
    <span>&nbsp;</span>
    <!-- Adds one space between the title and description -->
    <span v-if="titleDescription" class="text-body2"
      >({{ titleDescription }})</span
    >
  </div>
</template>
<script>
export default {
  name: "titleTitle",
};
</script>
<script setup>
const props = defineProps({
  title: {
    type: String,
  },
  titleDescription: {
    type: String,
  },
});
</script>
